/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * System in which portfolios of this type are created and maintained for the business relationship. CLM portfolios are created and edited in CLM. CBS (Core Banking System) portfolios are created in CBS and are view-only in CLM.
 * 
 * @export
 */
export const PortfolioManagedBy = {
    Clm: 'CLM',
    Cbs: 'CBS'
} as const;
export type PortfolioManagedBy = typeof PortfolioManagedBy[keyof typeof PortfolioManagedBy];


export function instanceOfPortfolioManagedBy(value: any): boolean {
    for (const key in PortfolioManagedBy) {
        if (Object.prototype.hasOwnProperty.call(PortfolioManagedBy, key)) {
            if (PortfolioManagedBy[key as keyof typeof PortfolioManagedBy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PortfolioManagedByFromJSON(json: any): PortfolioManagedBy {
    return PortfolioManagedByFromJSONTyped(json, false);
}

export function PortfolioManagedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioManagedBy {
    return json as PortfolioManagedBy;
}

export function PortfolioManagedByToJSON(value?: PortfolioManagedBy | null): any {
    return value as any;
}

export function PortfolioManagedByToJSONTyped(value: any, ignoreDiscriminator: boolean): PortfolioManagedBy {
    return value as PortfolioManagedBy;
}

